var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1448_267966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1448_267966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5C4.14167 5.5 4.26042 5.45208 4.35625 5.35625C4.45208 5.26042 4.5 5.14167 4.5 5C4.5 4.85833 4.45208 4.73958 4.35625 4.64375C4.26042 4.54792 4.14167 4.5 4 4.5C3.85833 4.5 3.73958 4.54792 3.64375 4.64375C3.54792 4.73958 3.5 4.85833 3.5 5C3.5 5.14167 3.54792 5.26042 3.64375 5.35625C3.73958 5.45208 3.85833 5.5 4 5.5ZM6 5.5C6.14167 5.5 6.26042 5.45208 6.35625 5.35625C6.45208 5.26042 6.5 5.14167 6.5 5C6.5 4.85833 6.45208 4.73958 6.35625 4.64375C6.26042 4.54792 6.14167 4.5 6 4.5C5.85833 4.5 5.73958 4.54792 5.64375 4.64375C5.54792 4.73958 5.5 4.85833 5.5 5C5.5 5.14167 5.54792 5.26042 5.64375 5.35625C5.73958 5.45208 5.85833 5.5 6 5.5ZM8 5.5C8.14167 5.5 8.26042 5.45208 8.35625 5.35625C8.45208 5.26042 8.5 5.14167 8.5 5C8.5 4.85833 8.45208 4.73958 8.35625 4.64375C8.26042 4.54792 8.14167 4.5 8 4.5C7.85833 4.5 7.73958 4.54792 7.64375 4.64375C7.54792 4.73958 7.5 4.85833 7.5 5C7.5 5.14167 7.54792 5.26042 7.64375 5.35625C7.73958 5.45208 7.85833 5.5 8 5.5ZM1 11V2C1 1.725 1.09792 1.48958 1.29375 1.29375C1.48958 1.09792 1.725 1 2 1H10C10.275 1 10.5104 1.09792 10.7063 1.29375C10.9021 1.48958 11 1.725 11 2V8C11 8.275 10.9021 8.51042 10.7063 8.70625C10.5104 8.90208 10.275 9 10 9H3L1 11ZM2.575 8H10V2H2V8.5625L2.575 8Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReply);
export default __webpack_public_path__ + "static/media/icon-reply.3e0d5119c8910c262cbf0b444afc0bf8.svg";
export { ForwardRef as ReactComponent };